import { Gradient } from 'types'

enum CreationToolRating {
    Unrated = 'CT_RATING_UNRATED',
    G = 'CT_RATING_G',
    PG = 'CT_RATING_PG',
    PG13 = 'CT_RATING_PG_13',
    R = 'CT_RATING_R',
}

namespace CreationToolRating {
    /**
     * Returns all ratings in order.
     */
    export function all(): CreationToolRating[] {
        return [
            CreationToolRating.Unrated,
            CreationToolRating.G,
            CreationToolRating.PG,
            CreationToolRating.PG13,
            CreationToolRating.R,
        ]
    }

    /**
     * Returns the rating's display title.
     */
    export function title(rating: CreationToolRating): string {
        switch (rating) {
            case CreationToolRating.Unrated:
                return 'Unrated'
            case CreationToolRating.G:
                return 'G'
            case CreationToolRating.PG:
                return 'PG'
            case CreationToolRating.PG13:
                return 'PG-13'
            case CreationToolRating.R:
                return 'R'
        }
    }

    /**
     * Returns the rating's description.
     */
    export function description(rating: CreationToolRating): string {
        switch (rating) {
            case CreationToolRating.Unrated:
                return 'Content that has not been rated.'
            case CreationToolRating.G:
                return 'Content that is appropriate for all ages.'
            case CreationToolRating.PG:
                return 'Content that is generally safe for everyone, but may require parental preview before children can watch.'
            case CreationToolRating.PG13:
                return 'Mild sexual innuendos, mild substance use, mild profanity, or threatening images. May include images of semi-naked people, but DOES NOT show real human genitalia or nudity.'
            case CreationToolRating.R:
                return 'Strong language, strong sexual innuendo, violence, and illegal drug use; not suitable for teens or younger. NO NUDITY.'
        }
    }

    /**
     * Returns the rating's value to use when uploading.
     */
    export function value(rating: CreationToolRating): string {
        switch (rating) {
            case CreationToolRating.Unrated:
                return ''
            case CreationToolRating.G:
                return 'g'
            case CreationToolRating.PG:
                return 'pg'
            case CreationToolRating.PG13:
                return 'pg13'
            case CreationToolRating.R:
                return 'r'
        }
    }

    export function normalize(rating: string): CreationToolRating {
        switch (rating) {
            case 'g':
                return CreationToolRating.G
            case 'pg':
                return CreationToolRating.PG
            case 'pg13':
                return CreationToolRating.PG13
            case 'r':
                return CreationToolRating.R
            default:
                return CreationToolRating.Unrated
        }
    }

    export function gradient(rating: CreationToolRating): Gradient | undefined {
        switch (rating) {
            case 'CT_RATING_G':
                return 'indigo-blue'
            case 'CT_RATING_PG':
                return 'indigo-purple'
            case 'CT_RATING_PG_13':
                return 'red-yellow'
            case 'CT_RATING_R':
                return 'red-pink'
            default:
                return
        }
    }
}

export default CreationToolRating
